import React from 'react';
const facts = [{
  value: '84',
  label: 'Ready-to-run vivencia plans'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '18',
  label: 'Printable worksheets'
}, {
  value: '3',
  label: 'Lengths: 75, 90, 120 min'
}];

// Colores de las fases del arco
const accents = ['before:bg-patrol-mustard', 'before:bg-ember', 'before:bg-moss', 'before:bg-patrol-teal'];
export function SocialProofBar() {
  return <section className="w-full bg-forest-deep" data-id="element-256" data-mp="32htewkm1ah8w">
      <div className="mx-auto max-w-6xl px-5 pb-12 sm:pb-16" data-id="element-257" data-mp="2xk0a9w0dpvaq">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-forest-line bg-forest-line sm:grid-cols-4" data-id="element-258" data-mp="2xktasf8qvokf">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-forest-deep px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-259" data-mp="2oiac87bzry3z" data-mpi={i}>
              <div className="font-display text-3xl leading-none text-ember sm:text-4xl" data-id="element-260" data-mp="1d2vg15rlxa9x">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-paper/65" data-id="element-261" data-mp="1dn5kzcnl3pi8">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}